import {CpfCnpjMaskPipe} from './../../shared/pipe/cpf-cnpj-mask.pipe';
import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SlideTogglePadraoComponent} from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {FormFieldComponent} from '../../shared/components/form-field/form-field.component';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {CelularMaskPipe} from '../../shared/pipe/celular-mask.pipe';
import {environment} from '../../../../environments/environment';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {UsuarioService} from '../../shared/service/usuario.service';
import {AuthService} from '../../shared/service/auth.service';
import {Usuario} from '../../shared/model/usuario/usuario.model';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import {MatOption} from '@angular/material/core';
import {SetorService} from '../../shared/service/setor.service';
import {IdNome} from '../../shared/model/id-nome.model';
import {SelectOneComponent} from '../../shared/components/select-one/select-one.component';

@Component({
  selector: 'app-modal-cadastro-visualizacao-operador',
  standalone: true,
  imports: [
    SlideTogglePadraoComponent,
    FormFieldComponent,
    ButtonPadraoComponent,
    CelularMaskPipe,
    CpfCnpjMaskPipe,
    ReactiveFormsModule,
    MatOption,
    SelectOneComponent,
  ],
  templateUrl: './modal-cadastro-visualizacao-operador.component.html',
  styleUrl: './modal-cadastro-visualizacao-operador.component.css'
})
export class ModalCadastroVisualizacaoOperadorComponent implements OnInit {
  visualizar = false;
  operador: Usuario = new Usuario();
  usuarios: Usuario[] = [];

  imgOperador?: SafeUrl;
  formGrupo!: FormGroup;
  telefoneOriginal?: number;
  cpfOriginal?: string;
  setores: IdNome[] = [];

  private readonly dialog = inject<MatDialogRef<ModalCadastroVisualizacaoOperadorComponent>>(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly usuarioService = inject(UsuarioService);
  private readonly setorService = inject(SetorService);
  private readonly authService = inject(AuthService);
  public alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly fb = inject(FormBuilder);

  ngOnInit() {
    this.formGrupo = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.minLength(3)]],
      setor: [null, [Validators.required]],
      telefone: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      cpf: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
    });

    const emailControl = this.formGrupo.get('email');
    if (emailControl) {
      emailControl.valueChanges.subscribe({
        next: value => {
          if (this.operador.email != value) {
            this.selecionarEmail(value);
          }
        }
      });
    }

    this.visualizar = this.data['visualizar'];
    this.operador = this.data['operador'];

    this.telefoneOriginal = this.operador.telefone;
    this.cpfOriginal = this.operador.cpf;

    if(!this.visualizar && !this.operador.id) {
      this.operador.ativo = true;
    }

    this.buscarSetores();
    this.carregarInfoOperador();
    this.alteracaoService.camposNaoAlterados();
  }

  buscarSetores() {
    this.setorService.buscarSetoresSelect().subscribe({
      next: res => this.setores = res
    });
  }

  protected carregarInfoOperador() {
    this.formGrupo.get('nome')?.patchValue(this.operador.nome);
    this.formGrupo.get('email')?.patchValue(this.operador.email);
    this.formGrupo.get('telefone')?.patchValue(this.operador.telefone);
    this.formGrupo.get('cpf')?.patchValue(this.operador.cpf);
    this.formGrupo.get('setor')?.patchValue(this.operador.setorDTO);

    if (this.operador.ldapHabilitado) {
      this.formGrupo.get('email')?.disable();
      this.formGrupo.get('nome')?.disable();
    }
    if (this.operador.cpf) {
      this.formGrupo.get('cpf')?.disable();
    }
  }

  salvar() {
    if (this.formGrupo.invalid) { return; }

    this.operador.nome = this.formGrupo.get('nome')!.value;
    this.operador.email = this.formGrupo.get('email')!.value;
    this.operador.telefone = this.formGrupo.get('telefone')!.value;
    this.operador.cpf = this.formGrupo.get('cpf')!.value;
    this.operador.setorDTO = this.formGrupo.get('setor') ? this.formGrupo.get('setor')!.value : this.operador.setorDTO;

    this.dialog.close(this.operador);
  }
  cancelar() { this.dialog.close(); }

  selecionarEmail(event: string) {
    this.usuarios = [];
    if (event) {
      if (event.includes("@")) {
        this.buscarUsuarioOperadorPorEmailEGrupo(event);
      } else {
        if (event.length > 5) {
          this.buscarUsuarioPeloAdEGrupo(event);
        }
      }
    }
  }

  buscarUsuarioOperadorPorEmailEGrupo(email: string) {
    this.usuarioService.buscarUsuariosPorEmailEGrupo(email).subscribe({
      next: res => {
        if (res.length > 0) {
          this.usuarios.push(...res);
        }
        this.usuarios = this.usuarios.sort((u1, u2) => {
          if (!u1.nome) return 1;
          if (!u2.nome) return -1;
          return u1.nome === u2.nome ? u1.id ? 1 : -1 : u1.nome > u2.nome ? -1 : 1;
        }).filter((item, pos, ary) => {
          return !pos || !item.id || (ary[pos - 1] && (!ary[pos - 1].id && item.id != ary[pos - 1].id) && !item.email?.includes(ary[pos - 1].email!));
        });
        this.operador = this.usuarios.length === 1 ? this.usuarios[0] : new Usuario();
      },
      complete: () => (this.operador && this.operador.id) ? this.carregarInfoOperador() : null
    });
  }

  buscarUsuarioPeloAdEGrupo(texto: string) {
    this.usuarioService.buscarUsuarioPeloAdEGrupo(texto).subscribe({
      next: res => {
        if (res.length > 0) {
          this.usuarios = [...res];
        }
      },
      complete: () => this.buscarUsuarioOperadorPorEmailEGrupo(texto)
    });
  }

  selecionarImgOperador(event: any) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target?.files[0]);
    reader.onload = () => {
      if(reader.result) {
        this.imgOperador = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
        this.operador.imgBase64 = reader.result.toString().split(';base64,')[1];
        this.operador.extensaoImg = reader.result.toString().split(';base64,')[0].split('/')[1];
      }
    };
  }

  verificarInteracaoTelefoneUsuario(atual: number){
    if (atual !== this.telefoneOriginal) {
      this.alteracaoService.camposAlterado();
    }
  }
  verificarInteracaoCpfUsuario(atual: string){
    if (atual !== this.cpfOriginal) {
      this.alteracaoService.camposAlterado();
    }
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }
}
